import {viewImagesApi} from "@/service";

/** 调用浏览器storage
 * @param key
 * @param value
 * @param boolean
 */
export function setStorage(key, value, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
    value = JSON.stringify(value)
  }
  storageObj.setItem(key, value)
}

// 判断是否是数组
export function ensureArray(param, isNumber = false) {
  // console.log(!param, '我是内容')
  if (!param) return [];

  if (Array.isArray(param)) {
    return param;
  } else if (typeof param === 'string') {
    // 使用逗号分割字符串，并去除首尾空格
    return param.split(',').map(item => (isNumber ? Number(item) : item.trim()));
  } else {
    return [];
  }
}

// 获取
export function getStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  return storageObj.getItem(key)
}

// 删除
export function removeStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  storageObj.removeItem(key)
}

// 清空所有
export function removeAllStorage(boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.localStorage
  } else {
    storageObj = window.sessionStorage
  }
  storageObj.clear()
}


// export function editorIsEmpty(str) {
//   //检查是否有文本
//   var value = str.replace(/\s/g, '').length;
//   //检查有图片？
//   var imgHave = (new RegExp("img", "ig")).test(str);
//   if (value > 0 || imgHave) { return true }
//   return false;
// }

export const editorIsEmpty = (str = '') => {

  if (str) {
    let regx = /<\/?[a-zA-Z]+(\s+[a-zA-Z]+=".*")*>/g;
    str = str.replaceAll(regx, '')
    console.log(str.length, '我是内容') // 我是内容
    return str.length
  }
}


// 判断两个数组是否有相同的元素
export const arrayEqual = (arr1, arr2) => {
  // arr2 可能是字符串带逗号的字符串
  arr2 = arr2.map(item => ensureArray(item)).flat()
  // arr1 是数组带逗号的字符串 需要转成数组平铺
  arr1 = arr1.map(item => ensureArray(item)).flat()
  // console.log(arr1, arr2, '我是内容')
  var flag = false
  for (let i = 0; i < arr1.length; i++) {
    if (arr2.includes(arr1[i])) {
      flag = true
      break;
    }
  }
  return flag
}

// sessionStorage对象存贮 oldData get set remove 编码转义
export const getOldData = (key) => {
  return JSON.parse(sessionStorage.getItem(key))
}
export const setOldData = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}


export const getUrlApi = async (id) => {
  let url = ''
  const key= 'k' + id;
  const oldData = sessionStorage.getItem(key) || ''
  if (oldData)  return oldData ;
  url = await viewImagesApi(id)
  sessionStorage.setItem(key, url)
  return url
}
